var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('div',[_c('div',{staticStyle:{"flex":"1"}},[_c('div',{staticClass:"content ql-editor"},[(_vm.supplier)?_c('supplier'):_vm._e(),(_vm.feedback)?_c('feedback'):_vm._e(),(_vm.regist)?_c('regist'):_vm._e(),(_vm.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e()],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }